<template>
	<NuxtLink>
		<slot />
	</NuxtLink>
</template>

<script setup lang="ts"></script>
